import dotenv from 'dotenv';
import path from 'path';

const currentDirThen = (dir) => path.join(__dirname, dir);

dotenv.config({
  path: currentDirThen('../../config/config.env'),
});
